import React, { Component } from 'react';
import Concert from "./concert"
import './concert.css'

import ScrollIndicator from "./ScrollIndicator.jsx";

/* Here is what is displayed on top, first of all */
const openingSection = (
  <div className="program-heading">
    <center>
       <h1>Varmt välkomna till Folkmusikkaféet</h1>
       Vi är en mötesplats för levande folkmusik och dans i Göteborg.<br/>Folkmusik och dans varje fredag.<br/><br/>
       <strong>Här har vi programmet för våren 2024 🎊</strong><br/>
  <br/>
  <small>
Bli medlem och få rabatt på inträdet. Du bidrar till att vi finns!<br/>
Du blir medlem i entrén på en konsertkväll<br/> eller genom att sätta in 50 kr på PG 107741-1, alt. Swish 1236279434. <br/>
  Ange namn, adress, telefonnummer och e-postadress.<br/>Medlemskap gäller per kalenderår.<br/>
<br/>
Konsertbiljetter köpes i entrén. Ingen förbokning.<br/>
Spel och danskvällar, heldanskväll och spelmansstämma har Fri entré.<br/>
  </small>
  </center>
  </div>);

/* Here the program is inserted! */
const theProgram = [
     <Concert
      title="Spel- och danskväll"
      date="2024-01-19"
      imgMaxWidth="95%"
      img="img/arkiv/spel_och_dans_1.jpg"
   >

     <div className="pBody">
       <center>

    Välkomna på Spel- och danskväll. På spel- och danskvällar är det dans till spellista. 1-3 grupper bokas för att inleda kvällen,
     därefter är det fritt fram att skriva upp sig på listan.

         <br/><br/>


<table className="program-tabell">
    <tr>
        <td>17:30-19:15</td>
        <td>Spelkurs</td>
      </tr>
    <tr>
        <td></td>
        <td><small>Spelmanslaget (se <a href="/kurser">kursinfo</a>)</small></td>
    </tr>
    <tr>
        <td>18:00-19:30</td>
        <td>Tillsammansgruppen</td>
      </tr>
    <tr>
        <td></td>
        <td><small>se <a href="/kurser">kursinfo</a></small></td>
    </tr>
    <tr>
        <td>18:30-19:30</td>
        <td>Dansstuga</td>
    </tr>
    <tr>
        <td></td>
        <td><small>Håkan och Ingela Lindberg lär ut polska från Bingsjö. Spelman: Björn Johnsson.</small></td>
    </tr>
    <tr>
        <td>18:30-19:30</td>
        <td>Visstuga</td>
    </tr>
    <tr>
        <td></td>
        <td><small>Mikael Rittri lär ut visor om älskog</small></td>
    </tr>
    <tr>
        <td>20:00-23:00</td>
        <td>Spel till dans</td>
    </tr>
    <tr>
        <td></td>
        <td><small>Triol och Kråkstråk inleder, sedan följer öppen spellista</small></td>
    </tr>
</table><br/>
<small>Kafévärd denna afton: Folkmusikkaféets styrelse med vänner</small>

   </center>
      </div>
  </Concert>,
     <Concert
      title="Storis Limpan Band"
      date="2024-01-26"
      imgMaxWidth="95%"
      cost={160} costYoung={130}
     img="img/program/vt2024/StorisLimpanBand.jpg"
   >

     <div className="pBody">
       <center>
       Möt Magnus ”Storis” Holmström från Bullmark i Västerbotten, trippel världsmästare på
Nyckelharpa, och gitarristen Tomas ”Limpan” Lindberg från Heby i Uppland, känd från
     folkmusikgruppen Draupner, i en sprakande konsert.<br/><br/>I 20år har Storis & Limpan turnérat
ihop i bland annat USA, Canada, Island, Tyskland och Turkiet, Tanzania och så klart i Sverige.
De har gjort allt från Bregottreklamer, via Melodifestivalen, till gästmusiker i metalbandet
     HammerFall.



<table className="program-tabell">
    <tr>
        <td>17:30-19:15</td>
        <td>Spelkurs</td>
      </tr>
    <tr>
        <td></td>
        <td><small>Spelmanslaget (se <a href="/kurser">kursinfo</a>)</small></td>
    </tr>

    <tr>
        <td>18:30-19:30</td>
        <td>Dansstuga</td>
    </tr>
    <tr>
        <td></td>
        <td><small>Maud Söderstedt och Lars-Gunnar Franzén lär ut schottis. Spelmän: Karin Westerståhl och Lennart Ehn.</small></td>
    </tr>
    <tr>
        <td>18:30-19:30</td>
        <td>Visstuga</td>
    </tr>
    <tr>
        <td></td>
        <td><small>Velizara Karaivanova lär ut bulgarisk folksång</small></td>
    </tr>
    <tr>
        <td>20:00-21:00</td>
        <td>Storis &amp; Limpan</td>
      </tr>
                <tr>
                  <td></td>
                  <td><small>I pausen spelar McRill</small></td>
                </tr>
    <tr>
        <td>21:00-23:00</td>
        <td>Spel till dans</td>
      </tr>

    <tr>
        <td></td>
        <td><small>Storis &amp; Limpan Band spelar till dans.</small></td>
    </tr>
</table><br/>
<small>Kafévärd denna afton: Folkmusikkaféets styrelse med vänner</small>


   </center>
   </div>
       </Concert>,
     <Concert
     title=<div>Project kvinnolåt,<br/><small>Anna Rynefors & Miriam Andersén</small></div>
      date="2024-02-02"
     imgMaxWidth="95%"

      cost={180} costYoung={150}
     img="img/program/vt2024/Kvinnolat.jpeg"
   >

     <div className="pBody">
       <center>
Anna Rynefors & Miriam Andersén har känt varann i tjugo år och står bägge med ett ben i
medeltidsmusiken och folkmusiken. De älskar att utforska nya områden i gränslandet mellan
dessa genrer och bjuder denna kväll på en berättarföreställning med projektet Kvinnolåt i
         vilket de skapat debutalbumet Skånska Spelkvinnor.


<table className="program-tabell">
    <tr>
        <td>17:30-19:15</td>
        <td>Spelkurs</td>
      </tr>
    <tr>
        <td></td>
        <td><small>Spelmanslaget (se <a href="/kurser">kursinfo</a>)</small></td>
    </tr>

    <tr>
        <td>18:00-19:30</td>
        <td>Danskurs</td>
    </tr>
    <tr>
        <td></td>
        <td><small>första gången (se <a href="/kurser">kursinfo</a>)</small></td>
    </tr>
    <tr>
        <td>18:30-19:30</td>
        <td>Dansstuga</td>
    </tr>
    <tr>
        <td></td>
        <td><small>Håkan och Ingela Lindberg lär ut Sønderhoning. Spelman: Björn Johnsson.</small></td>
    </tr>

    <tr>
        <td>20:00-21:00</td>
        <td>Kvinnolåt med Anna Rynefors &amp; Miriam Andersén</td>
    </tr>
    <tr>
        <td></td>
        <td><small>I pausen spelar Dan Olsson &amp; Lars-Gunnar Franzén</small></td>
    </tr>
    <tr>
        <td>21:00-23:00</td>
        <td>Spel till dans</td>
    </tr>
    <tr>
        <td></td>
        <td><small>Anna Rynefors &amp; Miriam Andersén spelar till dans</small></td>
    </tr>
</table><br/>
<small>Kafévärd denna afton: Bagaregårdens spelmanslag</small>


       </center>
      </div>
       </Concert>,
     <Concert
      title="Boda Mollkapell"
      date="2024-02-09"
     imgMaxWidth="95%"

      cost={180} costYoung={150}
     img="img/program/vt2024/MollkapelletMora.jpg"
   >
     <div className="pBody">
       <center>
Folkmusiken, med fokus på låtar från Boda, har alltid varit med medlemmarna i
folkmusikgruppen Boda mollkapell genom livet. De har inte musiken som yrke men på
fritiden spelar de och lever i folkmusiken. Boda mollkapell är kända för att spela mjuka, fina
         bodapolskor.<br/><br/>Tätorten Boda har en stor folkmusikskatt med många glömda låtar som här
fångats upp av ensemblen och börjat spelas igen. Kapellet består denna kväll av: Knapp
Britta, Lars Ljunggren, Jon Holmén och Knapp Karin på fioler samt Christina Ljunggren på
         cittra


<table className="program-tabell">
    <tr>
        <td>17:30-19:15</td>
        <td>Spelkurs</td>
      </tr>
    <tr>
        <td></td>
        <td><small>Spelmanslaget (se <a href="/kurser">kursinfo</a>)</small></td>
    </tr>

    <tr>
        <td>18:00-19:30</td>
        <td>Danskurs</td>
    </tr>
    <tr>
        <td></td>
        <td><small>andra gången (se <a href="/kurser">kursinfo</a>)</small></td>
    </tr>
    <tr>
        <td>18:30-19:30</td>
        <td>Dansstuga</td>
    </tr>
    <tr>
        <td></td>
        <td><small>Peter Nordqvist och Marie Schoondervaldt lär ut polska från Boda. Spelmän: Eva Blanck och Jan Nilsson</small></td>
    </tr>
    <tr>
        <td>18:30-19:30</td>
        <td>Spelstuga</td>
    </tr>
    <tr>
        <td></td>
        <td><small>Boda mollkapell lär ut låtar från Boda. Nyfiken på vilka låtar som kommer spelas? Kolla in vilka låtar som kommer spelas här <a href="https://drive.google.com/drive/folders/10lemvZSG--_kJWkDSMHxh5oOVAMa-L_r?usp=sharing">via denna länk!</a></small></td>
    </tr>
    <tr>
        <td>20:00-21:00</td>
        <td>Boda Molkapell</td>
    </tr>
    <tr>
        <td></td>
        <td><small>I pausen spelar Eva Blanck &amp; Jan Nilsson</small></td>
    </tr>
    <tr>
        <td>21:00-23:00</td>
        <td>Spel till dans</td>
    </tr>
    <tr>
        <td></td>
        <td><small>Boda Molkapell spelar till dans</small></td>
    </tr>
</table><br/>
<small>Kafévärd denna afton: Polskedanslaget</small>


       </center>
      </div>

       </Concert>,

     <Concert
      title="Anders Norudde & Karin Wallin"
      date="2024-02-16"
     imgMaxWidth="95%"

      cost={160} costYoung={130}
     img="img/program/vt2024/Norudde_Wallin.jpeg"
   >
     <div className="pBody">
       <center>

Anders från Värmland och Karin från Skåne. Två rutinerade folkmusiker med största
förkärlek till det råa klangfulla och omstämda möts här med stort sväng och kraftfullt
dansdriv i låtar från Värmland, Närke och Skåne.
<br/><br/>
Anders Norudde, uppväxt i Degerfors kom i kontakt med folkmusiken 1978 och bytte då ut
elgitarren mot en fiol. Tillägnade sig efterhand flera folkmusikinstrument såsom svensk
säckpipa, moraharpa, stråkharpa, vallhorn, sälgflöjt mfl. Startade gruppen Blå Bergens
Borduner 1984, och några år senare gruppen Hedningarna.<br/><br/>
Karin Wallin, uppväxt i Helsingborg bland dansande, dansforskande och sjungande
släktingar. 1975 väcktes det stora intresset för att spela till dans, skånska låtar till den
skånska folkliga danstraditionen som far Börje Wallin forskade fram. Här gällde det att få till
dansrytm, sväng och driv som passade dansarna och gärna då med platt stall och omständ
fiol för att kunna spela dubbelsträngat och få fram den stora klangen som spelmän gjorde
förr.

<table className="program-tabell">
    <tr>
        <td>17:30-19:15</td>
        <td>Spelkurs</td>
      </tr>
    <tr>
        <td></td>
        <td><small>Spelmanslaget (se <a href="/kurser">kursinfo</a>)</small></td>
    </tr>
    <tr>
        <td>18:00-19:30</td>
        <td>Danskurs</td>
    </tr>
    <tr>
        <td></td>
        <td><small>tredje gången (se <a href="/kurser">kursinfo</a>)</small></td>
    </tr>
    <tr>
        <td>18:30-19:30</td>
        <td>Dansstuga</td>
    </tr>
    <tr>
        <td></td>
        <td><small>Daniel Wallenius och Emelie Ström-Mattsson lär ut slängpolska. Spelmän: Karin Westerståhl och Lennart Ehn</small></td>
    </tr>
    <tr>
        <td>18:30-19:30</td>
        <td>Spelstuga</td>
    </tr>
    <tr>
        <td></td>
        <td><small>Lars-Gunnar Franzén lär ut låtar efter Lejsme Per</small></td>
    </tr>
    <tr>
        <td>20:00-21:00</td>
        <td>Anders Norudde &amp; Karin Wallin</td>
      </tr>
                <tr>
                  <td></td>
                  <td><small>I pausen spelar Borås spelmanslag</small></td>
                </tr>
    <tr>
        <td>21:00-23:00</td>
        <td>Spel till dans</td>
    </tr>
    <tr>
        <td></td>
        <td><small>Anders Norudde &amp; Karin Wallin spelar till dans.</small></td>
    </tr>
</table><br/>
<small>Kafévärd denna afton: Hisingens spelmanslag</small>


       </center>
      </div>



       </Concert>,

     <Concert
      title="Anders Almlöf & Gustav Melén"
      date="2024-02-23"
     imgMaxWidth="95%"

      cost={160} costYoung={130}
     img="img/program/vt2024/AndersoGustaf.jpeg"
   >

     <div className="pBody">
       <center>
Anders Almlöf  har sin musikaliska bakgrund i Malungstrakten. Han blev riksspelman 1999
         för utmärkt och traditionsrikt spel av låtar från Västerdalarna. Spelman och smed!<br/><br/>
Gustaf Melén är uppväxt i Hedemora, nu bosatt i Rättvikstrakten. En mångsysslare av den
         gamla stammen med såväl låtspel, snickeri och musikundervisning på repertoaren.    <br/><br/>          
De är spelkamrater sedan många år,  spelar gärna västerdalslåtar, men eftersom de nu bor i
Rättvikstrakten spelar de också  låtar därifrån. Naturlig inspiration har de fått  från Kalle
         Almlöf, Jonny Soling och Pers Hans.<br/><br/>
         Vi förväntar oss bra fart på dansgolvet, hög stämning!

         <br/><br/>
<table className="program-tabell">
    <tr>
        <td>17:30-19:15</td>
        <td>Spelkurs</td>
    </tr>
    <tr>
        <td></td>
        <td><small>Spelmanslaget (se <a href="/kurser">kursinfo</a>)</small></td>
    </tr>
    <tr>
        <td>18:00-19:30</td>
        <td>Danskurs</td>
    </tr>
    <tr>
        <td></td>
        <td><small>fjärde och sista gången (se <a href="/kurser">kursinfo</a>)</small></td>
    </tr>
    <tr>
        <td>18:30-19:30</td>
        <td>Dansstuga</td>
    </tr>
    <tr>
        <td></td>
        <td><small>Peter Nordqvist och Marie Schoondervaldt lär ut slängpolska från Malung efter Gucku Erik (Malungspolska 1). Spelman: Björn Johnsson</small></td>
    </tr>
    <tr>
        <td>18:30-19:30</td>
        <td>Spelstuga</td>
    </tr>
    <tr>
        <td></td>
        <td><small>Fred Sörensson lär ut irländska låtar</small></td>
    </tr>
    <tr>
        <td>20:00-21:00</td>
        <td>Anders Almlöf &amp; Gustaf Melén</td>
    </tr>
    <tr>
        <td></td>
        <td><small>I pausen spelar Bagaregårdens spelmanslag</small></td>
    </tr>
    <tr>
        <td>21:00-23:00</td>
        <td>Spel till dans</td>
    </tr>
    <tr>
        <td></td>
        <td><small>Anders Almlöf &amp; Gustaf Melén spelar till dans.</small></td>
    </tr>
</table><br/>
<small>Kafévärd denna afton: GNDS</small>

       </center>
     </div>
       </Concert>,

     <Concert
     title=<div>Heldanskväll,<br/><small>Tagel & Co, Urbanders och Höstrusk</small></div>
      date="2024-03-01"
      imgMaxWidth="95%"
     img="img/arkiv/spel_och_dans2.jpg"
   >
     <div className="pBody">
       <center>
         En helkväll för alla dansare. Tagel & Co, Urbanders och Höstrusk kommer att spela till dans
två halvtimmar var. Vi kan räkna med att det blir mycket polskor men också några
         gammaldanser.<br/><br/>

<table className="program-tabell">
    <tr>
        <td>17:30-19:15</td>
        <td>Spelkurs</td>
    </tr>
    <tr>
        <td></td>
        <td><small>Spelmanslaget (se <a href="/kurser">kursinfo</a>)</small></td>
    </tr>
    <tr>
        <td>17:30-19:00</td>
        <td>Årsmöte</td>
    </tr>
    <tr>
        <td>20:00-23:00</td>
        <td>Spel till dans</td>
    </tr>
    <tr>
        <td></td>
        <td><small>Tagel &amp; Co, Urbanders och Höstrusk</small></td>
    </tr>
</table><br/>
<small>Kafévärd denna afton: Balkandansarna</small>

       </center>
     </div>
       </Concert>,

     <Concert
     title=<div>Göteborg Folk Festival,<br/><small>Woodlands & Bäckafall</small></div>
     date="2024-03-08"
      cost={180} costYoung={150}
      imgMaxWidth="95%"
     img="img/program/vt2024/WoodlandsBackafall.jpg"
   >
     <div className="pBody">
       <center>
       Woodlands/Bäckafall är en powerkvartett som slår ihop den svenska midsommaren med
den irländska puben. Tillsammans tar de sig an och blåser nytt liv i den traditionella
låtskatten från Skottland och Sverige på harpa, gitarr, fiol, nyckelharpa och sång. Sånger på
gaeliska, franska, polska och engelska vävs lekfullt ihop med ösiga reels, smäktande valser
         och mystiska ballader i en indragande helhetsupplevelse.
         <br/><br/>

<table className="program-tabell">
    <tr>
        <td>17:30-19:15</td>
        <td>Spelkurs</td>
      </tr>
    <tr>
        <td></td>
        <td><small>Spelmanslaget (se <a href="/kurser">kursinfo</a>)</small></td>
    </tr>

    <tr>
        <td>18:30-19:30</td>
        <td>Dansstuga</td>
    </tr>
    <tr>
        <td></td>
        <td><small>Peter Nordqvist och Marie Schoonderwaldt lär ut schottisvariationer. Spelmän: Håkan och Ingela Lindberg.</small></td>
    </tr>
    <tr>
        <td>20:00-21:00</td>
        <td>Woodlands/Bäckafall</td>
    </tr>
    <tr>
        <td>21:00-24:00</td>
        <td>Spel till dans</td>
    </tr>
    <tr>
        <td></td>
        <td><small>Västkustfolk, FMK:s spelmanslag och Woodlands &amp; Bäckafall</small></td>
    </tr>
</table><br/>
<small>Kafévärd denna afton: Folk Youth</small>

       </center>
     </div>
       </Concert>,

     <Concert
      title="Ranrike spelmän"
      date="2024-03-15"
     imgMaxWidth="95%"

      cost={160} costYoung={130}
     img="img/program/vt2024/RanrikeSpelman.JPG"
   >
     <div className="pBody">
       <center>
Ranrike spelmän är ett spelmanslag som funnits i över 20 år som spelar bohuslänsk
folkmusik och har gett ut 2 album. Konserten bjuder på låtar ur den bohuslänska låtskatten
på instrument som fiol, dragspel, nyckelharpa, bas och klarinett. Därefter blir det dans med
en blandning av schottis, vals, hambo mm, samt rytmiska bohuspolskor, där det också
         stundtals märks inslag i polskorna från gränsen västerut.
         <br/><br/>

<table className="program-tabell">
    <tr>
        <td>17:30-19:15</td>
        <td>Spelkurs</td>
      </tr>
    <tr>
        <td></td>
        <td><small>Spelmanslaget (se <a href="/kurser">kursinfo</a>)</small></td>
    </tr>

    <tr>
        <td>18:00-19:30</td>
        <td>Tillsammansgruppen</td>
      </tr>

    <tr>
        <td></td>
        <td><small>se <a href="/kurser">kursinfo</a></small></td>
    </tr>
    <tr>
        <td>18:30-19:30</td>
        <td>Dansstuga</td>
    </tr>
    <tr>
        <td></td>
        <td><small>Håkan och Ingela Lindberg lär ut vals. Spelman: Björn Johnsson.</small></td>
    </tr>
    <tr>
        <td>18:30-19:30</td>
        <td>Visstuga</td>
    </tr>
    <tr>
        <td></td>
        <td><small>Robert Qvist lär ut visor om singelskap - "Jag vill alls ingen fästeman hava”</small></td>
    </tr>
    <tr>
        <td>20:00-21:00</td>
        <td>Ranrike spelmän</td>
    </tr>
    <tr>
        <td></td>
        <td><small>I pausen spelar Dan Palmqvist &amp; Daniel Austern</small></td>
    </tr>
    <tr>
        <td>21:00-23:00</td>
        <td>Spel till dans</td>
    </tr>
    <tr>
        <td></td>
        <td><small>Ranrike spelmän spelar till dans.</small></td>
    </tr>
</table><br/>
<small>Kafévärd denna afton: Folkmusikkaféets styrelse med vänner</small>

       </center>
     </div>
       </Concert>,

     <Concert
     title=<div>Stordanskväll,<br/>Fredrik Lundberg & Jonas Hjalmarsson<br/>samt Pelle Björnlert</div>
      date="2024-03-22"
     imgMaxWidth="95%"
      cost={160} costYoung={85}
     img="img/program/vt2024/jonas_fredrik.jpg"
     imgTwo="img/program/vt2024/PelleBjornlert.jpeg"
  >
     <div className="pBody">
       <center>
         På en stordanskväll är det dans hela kvällen – ingen konsert.<br/><br/>
När natten har övergått i gryning, i en dansloge på en spelmansstämma - där trivs dom som
bäst! Jonas Hjalmarsson och Fredrik Lundberg har spelat länge tillsammans och dansspelet
är det centrala. Repertoaren hämtar dom i Dalarna och Värmland hos Gössa Anders, Ole
Hjorth, Lejsme Per, Gunnar Orre, Magnus Olsson bland många andra. En stor del av
repertoaren är polskor, men även gammeldansens valser, schottisar och polkor står högt i
         kurs.<br/><br/>
Pelle Björnlert från Vråka i nordöstra Småland spelar företrädesvis musik som har sina rötter
i den småländska och östgötska folkmusiktraditionen. Pelle har stort fokus på låtarnas
ursprungliga funktion som bruks- och dansmusik och har under lång tid utvecklat sitt låtspel i
nära kommunikation med dansen. Tidigt skapade han sig ett namn i kraft av ett personligt
spelsätt med en smittande dansrytm och har länge varit en förebild för många spelmän från
         södra Sverige.
         <br/><br/>

<table className="program-tabell">
    <tr>
        <td>17:30-19:15</td>
        <td>Spelkurs</td>
      </tr>
    <tr>
        <td></td>
        <td><small>Spelmanslaget (se <a href="/kurser">kursinfo</a>)</small></td>
    </tr>

    <tr>
        <td>18:30-19:30</td>
        <td>Dansstuga</td>
    </tr>
    <tr>
        <td></td>
        <td><small>Peter Nordqvist och Marie Schoondervaldt lär ut polska från Övre Klarälvsdalen. Joar Skorpen spelar.</small></td>
    </tr>
    <tr>
        <td>18:30-19:30</td>
        <td>Spelstuga</td>
    </tr>
    <tr>
        <td></td>
        <td><small>Hans Grönlund lär ut låtar från norra och östra Värmland</small></td>
    </tr>
    <tr>
        <td>20:00-23:00</td>
        <td>Spel till dans</td>
    </tr>
    <tr>
        <td></td>
        <td><small>Jonas Hjalmarsson &amp; Fredrik Lundberg + Pelle Björnlert</small></td>
    </tr>
</table><br/>
<small>Kafévärd denna afton: Karin med vänner</small>


       </center>
     </div>


       </Concert>,

     <Concert
     title=<div>Thuva Härdelin,<br/><small>Föreställning "Helena Allena" + dans</small></div>
     date="2024-04-05"
      cost={160} costYoung={85}
      imgMaxWidth="95%"
     img="img/program/vt2024/Thuva_foto_Madeleine_Lind.jpg"
   >
     <div className="pBody">
       <center>
Berättelsen om Helena Allena är en sann berättelse. Eller så har den endast glimtar av
sanning. Helenas sanning. Hörsägen blandas med fakta och kryddas med myter och fantasi,
så som många berättelser inom folkkulturen sedan länge berättats. Detsamma kan sägas om
         traditionell folkmusik.<br/><br/>I mötet med samtida musik influeras, berikas och utvecklas den och
det är inte alltid lätt att urskilja de olika influenserna från varandra.
Under dansspelet kommer Thuva Härdelin och Fredy Samuel Lundh att avlösa varandra.



<table className="program-tabell">
    <tr>
        <td>17:30-19:15</td>
        <td>Spelkurs</td>
      </tr>
    <tr>
        <td></td>
        <td><small>Spelmanslaget (se <a href="/kurser">kursinfo</a>)</small></td>
    </tr>

    <tr>
        <td>18:00-19:30</td>
        <td>Tillsammansgruppen</td>
      </tr>

    <tr>
        <td></td>
        <td><small>se <a href="/kurser">kursinfo</a></small></td>
    </tr>

    <tr>
        <td>18:30-19:30</td>
        <td>Visstuga</td>
    </tr>
    <tr>
        <td></td>
        <td><small>Ann-Britt Lindhult lär ut visor från Västergötland efter Sven-Ingvar Heij</small></td>
    </tr>

    <tr>
        <td>18:30-19:30</td>
        <td>Dansstuga</td>
    </tr>
    <tr>
        <td></td>
        <td><small>Håkan och Ingela Lindberg lär ut snoepolska. Spelman: Björn Johnsson.</small></td>
    </tr>
    <tr>
        <td>20:00-21:00</td>
        <td>Thuva Härdelin</td>
      </tr>
    <tr>
        <td></td>
        <td><small>I pausen spelar Kristians kapell</small></td>
    </tr>

    <tr>
        <td>21:00-23:00</td>
        <td>Spel till dans</td>
    </tr>
    <tr>
        <td></td>
        <td><small>Thuva Härdelin och Fredy Samuel Lundh.</small></td>
    </tr>
</table><br/>
<small>Kafévärd denna afton: Polskedanslaget</small>


       </center>
     </div>

       </Concert>,

    <Concert
    title=<div>Spel- och danskväll,<br/><small>Västkustfolk och Torgny Lundberg</small></div>
      date="2024-04-12"
      imgMaxWidth="95%"
     img="img/program/vt2024/Vastkustfolk.jpeg"
  >
      <center>



<table className="program-tabell">
    <tr>
        <td>17:30-19:15</td>
        <td>Spelkurs</td>
      </tr>
    <tr>
        <td></td>
        <td><small>Spelmanslaget (se <a href="/kurser">kursinfo</a>)</small></td>
    </tr>

    <tr>
        <td>18:30-19:30</td>
        <td>Dansstuga</td>
    </tr>
    <tr>
        <td></td>
        <td><small>Peter Nordqvist och Alice Nordqvist lär ut Rørospols. Spelman: Joar Skorpen.</small></td>
    </tr>
    <tr>
        <td>20:00-23:00</td>
        <td>Spel till dans</td>
    </tr>
    <tr>
        <td></td>
        <td><small>Västkustfolk och Torgny Lundberg inleder, sedan följer öppen spellista</small></td>
    </tr>
</table><br/>
<small>Kafévärd denna afton: Skjortor och Särkar</small>

      </center>
       </Concert>,

    <Concert
    title=<div>Folk Youth,<br/><small>Västra Låtverkstan</small></div>
    date="2024-04-19"
    cost = {180} costYoung = {95}
      imgMaxWidth="95%"
     img="img/program/vt2024/VastraLatverkstan.jpg"
  >
      <div className="pBody">
      <center>
Ungdomar från hela regionen bjuder på tretakt och rockiga riff i en medryckande blandning!
Publiken får höra en svängig och inspirerande konsert med unga folkmusiker som framför
        folkmusik på nya och kreativa sätt.

        <br/><br/>


<table className="program-tabell">
    <tr>
        <td>17:30-19:15</td>
        <td>Spelkurs</td>
      </tr>
    <tr>
        <td></td>
        <td><small>Spelmanslaget (se <a href="/kurser">kursinfo</a>)</small></td>
    </tr>

    <tr>
        <td>18:30-19:30</td>
        <td>Spelstuga</td>
    </tr>
    <tr>
        <td></td>
        <td><small>Simon Ekenberg från Västra Låtverkstan lär ut västgötska favoritlåtar</small></td>
    </tr>
    <tr>
        <td>20:00-21:00</td>
        <td>Västra låtverkstan</td>
    </tr>
    <tr>
        <td>21:00-23:00</td>
        <td>Spel till dans</td>
    </tr>
    <tr>
        <td></td>
        <td><small>Västra låtverkstan, Jenny Gustafsson och Anders Ådin</small></td>
    </tr>
</table><br/>
<small>Kafévärd denna afton: Folk Youth VG</small>

    </center>
  </div>
       </Concert>,

    <Concert
      title="Spelmansstämma"
      date="2024-04-26"
      imgMaxWidth="95%"
     img="img/arkiv/stordanskväll.png"
  >
      <div className="pBody">
      <center>
        Välkommen på spelmansstämma, vårens final på Folkmusikkaféet!
        <br/><br/>

<table className="program-tabell">
    <tr>
        <td>17:30-19:15</td>
        <td>Spelkurs</td>
      </tr>
    <tr>
        <td></td>
        <td><small>Spelmanslaget (se <a href="/kurser">kursinfo</a>)</small></td>
    </tr>

    <tr>
        <td>19:00-20:00</td>
        <td>Allspel i stora salen under ledning av Dan Palmqvist. Här kan du ladda ned årets utökade allspelshäfte: <a href="filer/Allspelslatar_FMK_2024.pdf">Allspelslåtar 2024</a></td>
    </tr>
    <tr>
        <td>20:00-23:00</td>
        <td>Dans efter lista i stora salen</td>
    </tr>
    <tr>
        <td></td>
        <td><small>FMK:s spelmanslag, Tageltrång, Lei-la och Mams &amp; Paps inleder. Fortsatt buskspel i resten av huset hela kvällen.</small></td>
    </tr>
</table><br/>
<small>Kafévärd denna afton: Mams &amp; Paps</small>

    </center>
  </div>
       </Concert>,


];

const FadeInSection = ({
   children,
}) => {
   const domRef = React.useRef();

   const [isVisible, setVisible] = React.useState(false);

   React.useEffect(() => {
      const observer = new IntersectionObserver(entries => {
         // In your case there's only one element to observe:     
         if (entries[0].isIntersecting) {

            // Not possible to set it back to false like this:
            setVisible(true);

            // No need to keep observing:
            observer.unobserve(domRef.current);
         }
      });

      observer.observe(domRef.current);

      if (React.isValidElement(domRef.current)) {
         return () => observer.unobserve(domRef.current);
      }

   }, []);

   return (
      <section ref={domRef} className={isVisible ? 'entrySec is-visible' : 'entrySec'}>
         {children}
      </section>
   );
};


class Program extends Component {
   styles = {
      fontSize: 15,
      fontWeight: "bold"
   };

   constructor(props) {
      super(props);
      this.state = {
         isFetching: false,
         latest: null
      };
      this.sortArchive();
   }

   getProgram() {
      return theProgram;
   }

   sortArchive() {
      theProgram.sort((a, b) => {
         let dateDiff = a.props.date.localeCompare(b.props.date);
         if (dateDiff < 0) {
            return -1;
         } else if (dateDiff > 0) {
            return 1;
         }
         return 0;
      }
      );
   }

   render() {
      let theProgramCopy = [...theProgram];
      let scrollIndicator = (<ScrollIndicator />);

      while (theProgramCopy.length > 0) {
         let p = new Concert(theProgramCopy[0].props);
         if (!p.dateOK()) {
            theProgramCopy.shift();
         } else {
            break;
         }
      }

      if (theProgramCopy.length == 0) {
         return (
            <div>
               {openingSection}
               <center>
                  <h1>Tack för denna säsong!</h1>
                  Hoppas vi ses även nästa. Vi kommer snart att presentera kommande program.<br /><br />
                  <a href="/arkiv">Vårt arkiv över tidigare kvällar som varit</a>
                  <br /><br />
               </center>
            </div>
         );
      }

      if (theProgramCopy.length > 1) {
         let prog = [...theProgramCopy];
         let firstShow = prog.shift();
         /* All except the first one should have this swooch effect */
         let items = prog.map(concert => (
            <FadeInSection key={concert}>{concert}</FadeInSection>
         ));
         items.unshift(<div className="is-visible">{firstShow}</div>);
         return (<div>{scrollIndicator}{openingSection}{items}
            <br />
            <center>
               <a style={{
                  "font-size": "30px",
                  "border": "1px solid black",
                  "padding": "10px",
                  "border-radius": "5px"
               }} href="/arkiv">Tidigare program</a>
            </center>
            <br /><br />
            <br /></div>);
      }
     return (<div>{openingSection}{theProgram}
                   <center>
               <a style={{
                  "font-size": "30px",
                  "border": "1px solid black",
                  "padding": "10px",
                  "border-radius": "5px"
               }} href="/arkiv">Tidigare program</a>
            </center>
            <br /><br /></div>);
   }

}

export default Program;
